import { useTopicPageData } from '#src/app/pages/topic/pageContext';

type Result = ModelHookResult<{
	largePhotoUrl?: string | null;
	credit?: string | null;
	license?: string | null;
	platform?: string | null;
	source?: string | null;
	tag?: string | null;
}>;

export function useImageAttribution(): Result {
	const {
		data: { photos },
	} = useTopicPageData();

	const largePhotoUrl = photos[0]?.heroMedium?.url;
	const metadata = photos[0]?.metadata;

	return {
		data: {
			largePhotoUrl,
			...metadata,
		},
	};
}
